let nextId: number = 1;

export default function sessionUniqueId(prefix: string): string {
  const id = nextId;
  nextId += 1;
  return `${prefix || 'id'}-${id}`;
}
